import * as React from "react";
const SvgMore = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 14L12 10L8 6", stroke: "#666666", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMore;
